// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1hMkz","ranges":"BmiRanges_ranges__Qt9XX"};